import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";

export const selectExtraAppState = (state: RootState) => state.extraAppState;

export const selectAppValue = createSelector(
  selectExtraAppState,
  (state) => state.appValue,
);

export const selectAppUrl = createSelector(
  [selectAppValue],
  (value) => value?.extra_app_object.uri,
);

export const selectAppWithToken = createSelector(
  [selectAppValue],
  (value) => value?.extra_app_object?.withToken ?? false,
);

export const selectAppLoading = createSelector(
  selectExtraAppState,
  (state) => state.isLoading,
);
